import type { TFunction } from "i18next";
import { alsReistijd } from "@/features/reistijden/useReistijden";
import { toNumber } from "@/lib/paging";

/**
 * Read-only on both tabs: an override is keyed by coordinate pair, so it would correct the
 * reistijd for whoever else lives at that point (ADR-0053).
 */
export function reistijdCell(seconds: number | null, t: TFunction<"deelname">) {
  return seconds == null ? (
    <span className="text-muted-foreground">{t("gedeeld.geenReistijd")}</span>
  ) : (
    alsReistijd(seconds)
  );
}

export const reistijdWaarde = (seconds: number | string | null) =>
  seconds == null ? null : toNumber(seconds);
